import { ApiDealer, Dealer } from "./types";

export const parseAPIDealer = (apiDealer: ApiDealer[]): Dealer[] => {
    return apiDealer.map(parseSingleAPIDealer);
}

export const parseSingleAPIDealer = (apiDealer: ApiDealer): Dealer => {
    return {
        id: apiDealer.id,
        name: apiDealer.dealerName,
        url: apiDealer.urls && apiDealer.urls.length > 0 ? apiDealer.urls[0].url : "",
        siteType: apiDealer.siteType,
        dealerGroup: apiDealer.dealerGroup,
        dealerOrganizations: apiDealer.dealerOrganizations,
        industry: apiDealer.industry,
        websiteProvider: apiDealer.websiteProvider,
        lmPackage: apiDealer.lmPackage,
        phoneNumbers: apiDealer.phoneNumbers
    }
}